export const APP_VERSION = '5.0.0'; 
// API Base Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL,
  BASE_URL_QR: process.env.REACT_APP_URL_QR,
  TIMEOUT: 30000, // 30 seconds
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
} as const;

// Success Message Codes 
export const SUCCESS_CODES = [
  'IsOK',
  'Success'
] as const;

// Error Message Codes
export const ERROR_CODES = [
  'Exception',
  'HashCode',
  'HashCodeFalse',
  'AccountLocked',
  'LoginDateTime',
  'RefreshTokenExpired',
  'AuthenticateNotMatchRefresh',
  'LicenseExpired'
] as const;

// Permission bit positions (for funcsTagActive)
export const PERMISSION_BITS = {
  VIEW: 0,      // Xem/Đọc
  CREATE: 1,    // Thêm mới
  UPDATE: 2,    // Cập nhật/Sửa
  DELETE: 3,    // Xóa
  EXPORT: 4,    // Xuất dữ liệu
  IMPORT: 5,    // Nhập dữ liệu
  APPROVE: 6,   // Duyệt
  REJECT: 7     // Từ chối
} as const;

// Account Status Values
export const ACCOUNT_STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
  SUSPENDED: 2,
  LOCKED: 3
} as const;

// Default pagination values
export const PAGINATION_DEFAULTS = {
  SKIP: 0,
  TOP: 20,
  MAX_TOP: 1000
} as const;

// Date formats
export const DATE_FORMATS = {
  API_DATE: 'yyyyMMddHHmmss',
  DISPLAY_DATE: 'dd/MM/yyyy',
  DISPLAY_DATETIME: 'dd/MM/yyyy HH:mm:ss',
  ISO_DATE: 'yyyy-MM-dd',
  ISO_DATETIME: 'yyyy-MM-ddTHH:mm:ss'
} as const;

// Security headers
export const SECURITY_HEADERS = {
  AUTHENTICATE_TOKEN: 'AuthenticateToken',
  FUNCS_TAG_ACTIVE: 'funcsTagActive'
} as const;

// Storage keys
export const STORAGE_KEYS = {
  AUTHENTICATE_TOKEN: 'authenticateToken',
  REFRESH_TOKEN: 'refreshToken',
  EXPIRED_AUTHENTICATE_TOKEN: 'expiredAuthenticateToken',
  EXPIRED_REFRESH_TOKEN: 'expiredRefreshToken',
  SERVICE_URL: 'serviceUrl',
  USER_INFO: 'userInfo',
  PERMISSIONS: 'permissions',
  MENU_ITEMS: 'menuItems'
} as const;

// Common controllers
export const CONTROLLERS = {
  CAMERA: 'Camera',
  HE_THONG: 'HeThong',
  HOME: 'Home',
  DANH_MUC: 'DanhMuc',
  QUAN_LY: 'QuanLy',
  BAO_CAO: 'BaoCao',
  TAI_KHOAN: 'TaiKhoan',
  NGUOI_DUNG: 'NguoiDung'
} as const;

// Common actions
export const ACTIONS = {
  INDEX: 'Index',
  LIST: 'List',
  CREATE: 'Create',
  EDIT: 'Edit',
  UPDATE: 'Update',
  DELETE: 'Delete',
  DETAILS: 'Details',
  VIEW: 'View',
  EXPORT: 'Export',
  IMPORT: 'Import',
  APPROVE: 'Approve',
  REJECT: 'Reject'
} as const;

// Error messages (Vietnamese)
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Lỗi kết nối mạng. Vui lòng thử lại.',
  TIMEOUT_ERROR: 'Hết thời gian chờ. Vui lòng thử lại.',
  UNAUTHORIZED: 'Bạn không có quyền truy cập.',
  TOKEN_EXPIRED: 'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.',
  INVALID_CREDENTIALS: 'Tên đăng nhập hoặc mật khẩu không đúng.',
  ACCOUNT_LOCKED: 'Tài khoản đã bị khóa.',
  SERVER_ERROR: 'Lỗi máy chủ. Vui lòng thử lại sau.',
  VALIDATION_ERROR: 'Dữ liệu không hợp lệ.',
  NOT_FOUND: 'Không tìm thấy dữ liệu.',
  DUPLICATE_ERROR: 'Dữ liệu đã tồn tại.',
  HASH_CODE_ERROR: 'Mã bảo mật không hợp lệ.',
  API_DATE_ERROR: 'Thời gian API không hợp lệ.'
} as const;

// Success messages (Vietnamese)
export const SUCCESS_MESSAGES = {
  LOGIN_SUCCESS: 'Đăng nhập thành công!',
  LOGOUT_SUCCESS: 'Đăng xuất thành công!',
  REGISTER_SUCCESS: 'Đăng ký thành công!',
  CREATE_SUCCESS: 'Tạo mới thành công!',
  UPDATE_SUCCESS: 'Cập nhật thành công!',
  DELETE_SUCCESS: 'Xóa thành công!',
  SAVE_SUCCESS: 'Lưu thành công!',
  EXPORT_SUCCESS: 'Xuất dữ liệu thành công!',
  IMPORT_SUCCESS: 'Nhập dữ liệu thành công!'
} as const;
